const BRANCH_LABEL_BY_ID = Object.freeze({
  1: 'Arugambay A',
  2: 'Arugambay B',
});

const compact = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');

export function toBranchDisplayName({ branchId = 0, branchName = '', branchCode = '' } = {}) {
  const id = Number(branchId || 0);
  if (Object.prototype.hasOwnProperty.call(BRANCH_LABEL_BY_ID, id)) {
    return BRANCH_LABEL_BY_ID[id];
  }

  const code = compact(branchCode);
  if (code === 'ab1' || code === 'arugambay1') return BRANCH_LABEL_BY_ID[1];
  if (code === 'ab2' || code === 'arugambay2') return BRANCH_LABEL_BY_ID[2];

  const name = String(branchName || '').trim();
  if (!name) return id > 0 ? `Branch ${id}` : 'Branch';

  const nameKey = compact(name);
  if (nameKey.includes('arugambay1') || nameKey.includes('arugamabay1')) {
    return BRANCH_LABEL_BY_ID[1];
  }
  if (nameKey.includes('arugambay2') || nameKey.includes('arugamabay2')) {
    return BRANCH_LABEL_BY_ID[2];
  }

  return name;
}
